import { useEffect, useRef, useState } from "react";
import { ShieldAlert } from "lucide-react";

// Global cool-down banner — listens for the `ai-rate-limit` event broadcast by
// the axios interceptor on any HTTP 429 (provider FUP or our own throttle) and
// shows a polite high-contrast countdown, then auto-hides. Masks nothing
// destructively; it simply informs the user to wait before the next generation.
export default function RateLimitBanner() {
  const [left, setLeft] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    const onLimit = (e) => {
      const secs = Math.max(5, Math.min(120, Number(e?.detail?.seconds) || 60));
      setLeft(secs);
    };
    window.addEventListener("ai-rate-limit", onLimit);
    return () => window.removeEventListener("ai-rate-limit", onLimit);
  }, []);

  useEffect(() => {
    if (left <= 0) return;
    timerRef.current = setInterval(() => setLeft((s) => (s <= 1 ? 0 : s - 1)), 1000);
    return () => clearInterval(timerRef.current);
  }, [left]);

  if (left <= 0) return null;

  return (
    <div
      data-testid="rate-limit-banner"
      className="fixed inset-x-0 top-0 z-[200] flex items-center justify-center gap-2 border-b-4 border-black bg-[#FF3B3B] px-3 py-2.5 shadow-[0_4px_0px_0px_rgba(0,0,0,1)]"
    >
      <ShieldAlert size={16} className="shrink-0 text-black" />
      <span data-testid="rate-limit-readout" className="font-mono text-[10px] font-black uppercase tracking-wider text-black sm:text-xs">
        [ RATE LIMIT ACTIVE: PROVIDER COOL-DOWN IN PROGRESS — RESUMING IN {left}s ]
      </span>
    </div>
  );
}
